export default __webpack_public_path__ + "static/media/barn-contact-1.79d23e54.png";